import { render } from "./index.vue?vue&type=template&id=475703ff&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=475703ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475703ff"],['__file',"src/components/scPageHeader/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "475703ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('475703ff', __exports__)) {
    api.reload('475703ff', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=475703ff&scoped=true", () => {
    api.rerender('475703ff', render)
  })

}


export default __exports__